export function printBenchmarkHelp(): void {
  console.log(
    [
      'Usage: cofactor benchmark <sub-command> [options]',
      '',
      'Sub-commands:',
      '  workflows                       List benchmark-org workflows (arm picker source)',
      '  ab [options]                    Launch an ad-hoc A/B experiment',
      '  list                            List recent benchmark suite runs',
      '  report <suiteId>                Per-arm comparison table for a suite run',
      '  import <workflowId>             Copy a workflow into the benchmark org',
      '',
      '`ab` options:',
      '  --workflow <id>                 Workflow to include (repeatable)',
      '  --all                           Use every benchmark-org workflow',
      '  --runs-per-arm <n>              Runs per workflow per arm (1–20; server default 3)',
      '  --arm <label>                   Open a new arm (1–4). Flags below attach to it:',
      '    --model <model>[@<provider>]  Pin the arm model (safe cross-provider routing)',
      '    --knob <key>=<value>          Pin any knob (repeatable; value typed by inference)',
      '    --flag <name>=<v>             Pin any flag: true|false|treatment|control (repeatable)',
      '',
      'Example:',
      '  cofactor benchmark ab --all --runs-per-arm 2 \\',
      '    --arm baseline --model gpt-5.4 \\',
      '    --arm terra    --model gpt-5.6-terra \\',
      '    --arm sonnet   --model claude-sonnet-5@azure',
      '',
      'Global options: --env <env>  --json  --api-url <url>  --token <key>',
    ].join('\n')
  );
}
